<div class="form-group">
  <angular-editor
    data-test="description"
    #description
    [ngClass]="{'is-invalid': invalidInput}"
    [(ngModel)]="input"
    [config]="config"
    (ngModelChange)="valueChanged($event)"
    (blur)="onTouch()"
  ></angular-editor>
</div>